import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import useParametrosEntidade from '../hooks/useParametrosEntidade';
import DataMaskInput from '../masks/DataMaskInput';

function ArpOrdemModal({ show, arpOrdem, arp, onClose, onSave, dataUltimaOrdem }) {
  const [formData, setFormData] = useState({ data: '', idProprio: '' });
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { params: paramsEntidade } = useParametrosEntidade(arp?.idEntidade);

  useEffect(() => {
    if (show) {
      if (arpOrdem) {
        setFormData({ data: formatDate(arpOrdem.data), idProprio: arpOrdem.idProprio || '' });
      } else {
        setFormData({ data: '', idProprio: '' });
        setTimeout(() => { try { dateInputRef.current && dateInputRef.current.focus(); } catch (e) {} }, 80);
      }
      setValidated(false);
    }
  }, [show, arpOrdem]);

  const formatDate = date => {
    if (!date) return '';
    if (Array.isArray(date)) {
      const [year, month, day] = date;
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    }
    if (typeof date === 'string') return date.split('T')[0];
    return '';
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.data) {
      setValidated(true);
      return;
    }

    function soData(date) {
      if (!date) return null;
      if (Array.isArray(date)) {
        const [y, m, d] = date;
        return { y, m: m - 1, d };
      }
      if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        const [y, m, d] = date.split('-').map(Number);
        return { y, m: m - 1, d };
      }
      const dObj = new Date(date);
      return { y: dObj.getFullYear(), m: dObj.getMonth(), d: dObj.getDate() };
    }
    function menorQue(a, b) {
      if (!a || !b) return false;
      if (a.y !== b.y) return a.y < b.y;
      if (a.m !== b.m) return a.m < b.m;
      return a.d < b.d;
    }

    const dataOrdem = soData(formData.data);
    const dataInicio = soData(arp?.dataInicio);
    const dataFim = arp?.dataFim ? soData(arp.dataFim) : null;
    const dataUltimo = dataUltimaOrdem ? soData(dataUltimaOrdem) : null;

    if (dataInicio && menorQue(dataOrdem, dataInicio)) {
      showDefaultModal('error', 'A data da ordem não pode ser anterior à data de início da ARP.');
      return;
    }
    if (dataFim && menorQue(dataFim, dataOrdem)) {
      showDefaultModal('error', 'A data da ordem não pode ser posterior à data de fim da ARP.');
      return;
    }
    if (dataUltimo && menorQue(dataOrdem, dataUltimo)) {
      showDefaultModal('error', 'A data da ordem não pode ser anterior à data da última ordem cadastrada.');
      return;
    }

    setLoading(true);
    const payload = {
      ...formData,
      id: arpOrdem?.id || null,
      idProprio: formData.idProprio || null,
      idArp: arp.id,
      usuario: user.login || 'Sistema',

    };

    try {
      if (arpOrdem?.id) {
        await axios.put(`${API_BASE_URL.ARP_ORDEM}/${arp.id}/${arpOrdem.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave();
        if (onClose) onClose();
        showDefaultModal('success', 'Ordem atualizada com sucesso!');
      } else {
        const response = await axios.post(API_BASE_URL.ARP_ORDEM, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (onSave) onSave(response.data);
        if (onClose) onClose();
        showDefaultModal('success', 'Ordem cadastrada com sucesso!');
      }
    } catch (error) {
      console.error('Erro ao salvar ordem:', error);
      const msg = error?.response?.data?.error || 'Erro ao salvar ordem. Verifique os dados e tente novamente.';
      showDefaultModal('error', msg);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-truck me-2"></i>
                {arpOrdem ? 'Editar Ordem de Fornecimento' : 'Nova Ordem de Fornecimento'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={loading} title="Fechar"></button>
            </div>
            <div className="modal-body">
              <div className="alert alert-info mb-3 py-2">
                <small>
                  <i className="bi bi-info-circle me-2"></i>
                  ARP: <strong>{arp?.numArp}</strong>
                  {arp?.fornecedor && <> - {arp.fornecedor.nome}</>}
                </small>
              </div>

              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Data <span className="text-danger">*</span>
                      </label>
                      <DataMaskInput
                        name="data"
                        value={formData.data}
                        onChange={handleChange}
                        disabled={loading || !!arpOrdem}
                        className={validated && !formData.data ? 'is-invalid' : ''}
                      />
                      {validated && !formData.data && (
                        <div className="invalid-feedback">Por favor, informe a data.</div>
                      )}
                    </div>
                  </div>
                  {paramsEntidade.EDITAR_ID_PROPRIO !== 'N' && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label small fw-semibold">Id Próprio</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          name="idProprio"
                          value={formData.idProprio}
                          onChange={handleChange}
                          maxLength={20}
                          disabled={loading}
                          placeholder="Ex: OF001/2024"
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                    <i className="bi bi-x-circle me-1"></i>Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
                    ) : (
                      <><i className="bi bi-check-circle me-1"></i>Salvar</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default ArpOrdemModal;
